type SortableVersion = {
  sequenceNumber: number;
};

// Returns a new array sorted by sequenceNumber, descending by default; empty array for undefined input.
export const sortVersionsBySequence = <T extends SortableVersion>(versions: T[] | undefined, ascending: boolean): T[] => {
  if (!versions) {
    return [];
  }

  return [...versions].sort((a, b) => (ascending ? a.sequenceNumber - b.sequenceNumber : b.sequenceNumber - a.sequenceNumber));
};
